import { Box } from "@mui/material";
import dayjs from "dayjs";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PostKbn } from "../../assets/data/Constants";
import { GlobalContext } from "../../context/globalContext";
import { TkGetCode } from "../../utils/TkGetCode";
import "./_style.scss";
import { httpAPI_CHA002, httpAPI_CHA003, httpAPI_CHA004 } from "./api/request";
import {
  MessageDialog,
  PersonInChargeSerchDialog,
} from "./components/components";

interface SCRW150002Props {
  open: boolean;
  contractorNo: string;
  threadId?: number;
  onClose?: any;
}

/**
 * SCRW150002_法人との連絡掲示板
 * @return SCRW150002_法人との連絡掲示板
 */
const SCRW150002: React.FC<SCRW150002Props> = (props) => {
  const { contractorNo, threadId, open, onClose } = props;
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const [reStart, setReStart] = useState<any>();
  const [messageList, setMessageList] = useState<any[]>([]);
  const [isOpen, setIsOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [nowThreadId, setNowThreadId] = useState<number>();

  async function openingScreen() {
    // スレッド詳細一覧参照API 呼び出し
    try {
      const res = await httpAPI_CHA003({
        threadId,
        contractorNo: contractorNo,
      });

      if (res.resultCd === "I0000") {
        if (res.finishFlg === "1" || !res.finishFlg) {
          setReStart(false);
        } else {
          setReStart(true);
        }

        let newThreadList: any[] = [];
        if (res.noticeBoardThreadList) {
          const threadList = res.noticeBoardThreadList as {
            [key: string]: any;
          };
          threadList.forEach((i: any) => {
            const data = {
              personalType: TkGetCode(PostKbn, i.postKbn),
              message: i.chatDetail,
              fileName: i?.fileName,
              fileBase64: i?.fileBase64,
            };
            newThreadList.push(data);
          });
        } else {
          newThreadList.push([]);
        }
        setNowThreadId(res.threadId);
        setMessageList(newThreadList);
        setIsOpen(true);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  }

  useEffect(() => {
    open && openingScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleClose = () => {
    setIsOpen(false);
    setMessageList([]);
    onClose && onClose();
  };

  const onSend = async (e: any) => {
    // スレッド詳細更新API 呼び出し
    try {
      const res = await httpAPI_CHA004({
        threadId: nowThreadId,
        postKbn: PostKbn["機構"],
        postUserId: state.authInfo?.userId!,
        chatDetail: e?.message,
        fileName: e?.file?.fileName,
        fileBase64: e?.file?.fileBase64,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const onStart = () => {
    setOpenDialog(true);
  };

  const serchSuccess = async (e: any) => {
    // スレッド更新API 呼び出し
    try {
      const res = await httpAPI_CHA002({
        contractorNo: contractorNo,
        registDate: dayjs().format("YYYY/MM/DD"),
        finishFlg: "0",
        corpUserId: e,
        wamUserId: state.authInfo?.userId,
      });

      if (res.resultCd === "I0000") {
        setReStart(true);
        setOpenDialog(false);
        setNowThreadId(res.threadId);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const serchClose = () => {
    setOpenDialog(false);
  };

  useEffect(() => {
    !!nowThreadId && setIsOpen(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reStart]);

  return (
    <Box data-testid="SCRW150002PageForTest">
      <MessageDialog
        open={isOpen}
        handleClose={handleClose}
        messages={messageList}
        reStart={reStart}
        onSend={onSend}
        onStart={onStart}
      />
      <PersonInChargeSerchDialog
        open={openDialog}
        contractorNo={contractorNo}
        onSuccess={serchSuccess}
        onClose={serchClose}
      />
    </Box>
  );
};

export default SCRW150002;
